import { IconButton } from '@mui/material'
import { Heart } from '@phosphor-icons/react'
import React from 'react'
import { ApplicationTypes } from 'sunlife-domain'

import { configuratorInterface } from '../../systems/configurator-interface'

export const AddToWishlistButton: React.FC = () => {
  const { storeSystem, navigationSystem } = configuratorInterface.useDomain()
  return (
    <IconButton
      color="primary"
      onClick={() => {
        storeSystem.stageAndCommit([
          navigationSystem.getNavigationUpdate(ApplicationTypes.NavigationState.FinalizeWishlist),
        ])
      }}
      sx={{
        border: '1px solid',
        borderColor: 'primary.main',
      }}
      title="Add to wishlist"
    >
      <Heart size={20} />
    </IconButton>
  )
}
